query homeNumber($id: ID!, $tz: String) {
  homeNumber(id: $id) {
    id
    label
    formattedNumber
    number
    deletedAt(tz: $tz)
    deletingTeacher {
      id
      first
      isCurrent
      last
    }
    archivedAt(tz: $tz)
    archivingTeacher {
      id
      first
      isCurrent
      last
    }
    blockedAt(tz: $tz)
    blockingTeacher {
      id
      first
      isCurrent
      last
    }
    canMakeCallTo
    canReceiveCallFrom
    conversations {
      teacherPhoneNumber {
        id
        displayName
      }
    }
    homeLanguage {
      id
      language
      name
      order
    }
    students {
      id
      first
      last
    }
  }
}
